/**
 * The leave planner's team token (a JWT from login, valid 8 hours), shared by
 * the tabs of this browser. The rest of the login lives per tab
 * (sessionStorage), so a link from a planner mail, which opens a new tab,
 * would otherwise have no token. Removed again on logout.
 */
const KEY = 'team_token';

/** Expiry (ms) from the token's payload, or 0 when it cannot be read. */
const expiresAt = (token) => {
    try {
        const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(part + '='.repeat((4 - (part.length % 4)) % 4)));
        return typeof payload.exp === 'number' ? payload.exp * 1000 : 0;
    } catch (e) {
        return 0;
    }
};

export const storeTeamToken = (token) => {
    try {
        if (token) localStorage.setItem(KEY, token);
    } catch (e) { /* storage blocked */ }
};

/** The stored token when it is still valid for at least a minute, else ''. */
export const readTeamToken = () => {
    try {
        const token = localStorage.getItem(KEY) || '';
        if (token && expiresAt(token) > Date.now() + 60000) return token;
        if (token) localStorage.removeItem(KEY);
    } catch (e) { /* storage blocked */ }
    return '';
};

export const clearTeamToken = () => {
    try { localStorage.removeItem(KEY); } catch (e) { /* storage blocked */ }
};

/** Pages of the planner that a login may return to (no open redirects). */
export const isTeamPath = (path) => /^\/[a-z]{2}\/team\/?(\?tab=[a-z]+)?$/.test(path || '');
